import { render, staticRenderFns } from "./OrgManager.vue?vue&type=template&id=db450efe&scoped=true&"
import script from "./OrgManager.vue?vue&type=script&lang=js&"
export * from "./OrgManager.vue?vue&type=script&lang=js&"
import style0 from "./OrgManager.vue?vue&type=style&index=0&id=db450efe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db450efe",
  null
  
)

export default component.exports